function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["containerProps", "item", "onDragEnd", "onDragHandlePointerDown", "onDragHandlePointerUp"];
var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/ManageSection/index.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import ScrollbarWidthOffset from "@mlb/react-patterns/dist/components/ScrollbarWidthOffset/scrollbarWidthOffset";
import ScrollLock from "@mlb/react-patterns/dist/components/ScrollLock/scrollLock";
import useEventListener from "@mlb/react-patterns/dist/utils/hooks/useEventListener/useEventListener";
import { AnimatePresence, Reorder, useDragControls } from "framer-motion";
import React, { useEffect, useState } from "react";
import ManageFollowRow from "../ManageFollowRow";
import { ManageSectionContainer, ManageSectionHeader, ManageSectionListContainer, ManageSectionNoDataButton } from "./styles";
var ComponentKey = "manage-section";
var ResetRowDataAttribute = "data-row-showing-remove";
var ManageSection = function ManageSection(_ref) {
  var className = _ref.className,
    containerProps = _ref.containerProps,
    headerLabel = _ref.headerLabel,
    headerProps = _ref.headerProps,
    isFavorite = _ref.isFavorite,
    items = _ref.items,
    listContainerProps = _ref.listContainerProps,
    noDataButtonLabel = _ref.noDataButtonLabel,
    noDataButtonProps = _ref.noDataButtonProps,
    onDelete = _ref.onDelete,
    onNoDataButtonClick = _ref.onNoDataButtonClick,
    onRemove = _ref.onRemove,
    onReorder = _ref.onReorder,
    rowProps = _ref.rowProps,
    scrollableElementRef = _ref.scrollableElementRef,
    type = _ref.type;
  var originalItems = items;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    rowBeingDragged = _useState2[0],
    setRowBeingDragged = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    rowShowingRemove = _useState4[0],
    setRowShowingRemove = _useState4[1];
  var _useState5 = useState(items),
    _useState6 = _slicedToArray(_useState5, 2),
    reorderedItems = _useState6[0],
    setReorderedItems = _useState6[1];
  var numberOfRows = (reorderedItems === null || reorderedItems === void 0 ? void 0 : reorderedItems.length) || 0;
  var isReorderable = numberOfRows > 1;
  useEffect(function () {
    setReorderedItems(items);
    setRowShowingRemove(null);
  }, [items]);

  /**
   * Add click listener on document.
   * If there is a row showing remove and the click is outside of it, then reset to default state
   */
  useEventListener("click", function (event) {
    if (rowShowingRemove) {
      var row = document.querySelector("[".concat(ResetRowDataAttribute, "=\"true\"]"));
      if (row && !row.contains(event.target)) {
        setRowShowingRemove(null);
      }
    }
  }, document, {
    capture: true
  });
  var onDragEnd = function onDragEnd() {
    if (onReorder) {
      /**
       * Only call onReorder if the order actually changed.
       * Otherwise, grabbing and releasing a row in the same position would call onReorder and it would be extraneous.
       */
      var originalIds = originalItems.map(function (item) {
        return item.id;
      }).join(",");
      var reorderedIds = reorderedItems.map(function (item) {
        return item.id;
      }).join(",");
      if (originalIds !== reorderedIds) {
        onReorder({
          items: reorderedItems,
          type: type
        });
      }
    }
  };
  return /*#__PURE__*/React.createElement(ManageSectionContainer, _extends({
    className: className,
    "data-testid": ComponentKey
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 5
    }
  }), rowBeingDragged && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollbarWidthOffset, {
    container: scrollableElementRef === null || scrollableElementRef === void 0 ? void 0 : scrollableElementRef.current,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(ScrollLock, {
    element: scrollableElementRef === null || scrollableElementRef === void 0 ? void 0 : scrollableElementRef.current,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(ManageSectionHeader, _extends({}, headerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 7
    }
  }), headerLabel), /*#__PURE__*/React.createElement(ManageSectionListContainer, _extends({
    as: Reorder.Group,
    axis: "y",
    numberOfRows: numberOfRows,
    onReorder: setReorderedItems,
    rowBeingDragged: rowBeingDragged,
    values: reorderedItems
  }, listContainerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(AnimatePresence, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 9
    }
  }, numberOfRows > 0 ? reorderedItems.map(function (item) {
    var isRowShowingRemove = rowShowingRemove === item.id;
    return /*#__PURE__*/React.createElement(ManageFollowRowWithDrag, _extends({}, item, {
      containerProps: _defineProperty({}, ResetRowDataAttribute, isRowShowingRemove),
      isFavorite: isFavorite,
      item: item,
      key: item.id,
      onDeleteClick: function onDeleteClick(e) {
        setRowShowingRemove(item.id);
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(e, _objectSpread(_objectSpread({}, item), {}, {
          type: type
        }));
      },
      onRemoveClick: function onRemoveClick(e) {
        return onRemove === null || onRemove === void 0 ? void 0 : onRemove(e, _objectSpread(_objectSpread({}, item), {}, {
          type: type
        }));
      },
      onDragEnd: onDragEnd,
      onDragHandlePointerDown: function onDragHandlePointerDown() {
        if (rowShowingRemove) {
          setRowShowingRemove(null);
        }
        setRowBeingDragged(item.id);
      },
      onDragHandlePointerUp: function onDragHandlePointerUp() {
        return setRowBeingDragged(null);
      },
      showDragHandle: isReorderable,
      showRemove: isRowShowingRemove,
      type: type
    }, rowProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 106,
        columnNumber: 17
      }
    }));
  }) : /*#__PURE__*/React.createElement(ManageSectionNoDataButton, _extends({
    handlers: {
      onClick: onNoDataButtonClick
    }
  }, noDataButtonProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 13
    }
  }), noDataButtonLabel))));
};
export default /*#__PURE__*/React.memo(ManageSection);

/**
 * A simple wrapper around ManageFollowRow to make it draggable.
 * The use of `useDragControls` makes it necessary to wrap in a component.
 */
var ManageFollowRowWithDrag = function ManageFollowRowWithDrag(_ref3) {
  var containerProps = _ref3.containerProps,
    item = _ref3.item,
    onDragEnd = _ref3.onDragEnd,
    _onDragHandlePointerDown = _ref3.onDragHandlePointerDown,
    onDragHandlePointerUp = _ref3.onDragHandlePointerUp,
    props = _objectWithoutProperties(_ref3, _excluded);
  var dragControls = useDragControls();
  return /*#__PURE__*/React.createElement(ManageFollowRow, _extends({
    containerProps: _objectSpread(_objectSpread({}, containerProps), {}, {
      as: Reorder.Item,
      "data-drag-target": item.id,
      dragControls: dragControls,
      dragListener: false,
      onDragEnd: onDragEnd,
      value: item
    })
  }, props, {
    onDragHandlePointerDown: function onDragHandlePointerDown(e) {
      dragControls.start(e);
      _onDragHandlePointerDown === null || _onDragHandlePointerDown === void 0 ? void 0 : _onDragHandlePointerDown(e);
    },
    onDragHandlePointerUp: onDragHandlePointerUp,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 5
    }
  }));
};